import React, { useRef, useState } from 'react'
import './element-savetomycontent.styles.scss';
import { ModalAlert, ModalConfirm } from '@/components/modal/modal.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-regular-svg-icons';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';
import { useSelector } from 'react-redux';
import { UseCloudFunction } from '@/utils/firebase.utils';
import { RandomString } from '@/utils/randomString';

const ElementSaveToMyContent = ({
    gameData,
    element,
    onComplete,
    style,
    classText,
}) => {

    const userProfile = useSelector(state => state.userData.userProfile);
    const [ loading, setLoading ] = useState(false);
    const [ alertMessage, setAlertMessage ] = useState(null);
    const [ confirmMessage, setConfirmMessage ] = useState(null);
    const approveRef = useRef();

    function saveElementToMyContent() {
        setConfirmMessage('Are you sure you want to add this element to your My Content collection?')
        approveRef.current = () => {
            continueSave();
        }

        async function continueSave() {
            setLoading(true);
            let category;
            switch (element.type) {
                case 'badge':
                    category = 'Badges';
                    break;
                case 'challenge':
                    category = 'Challenges';
                    break;
                case 'secretCode':
                    category = 'Secret Codes';
                    break;
                case 'level':
                    category = 'Levels';
                    break;
                case 'item':
                    category = 'Items';
                    break;
            }
            const now = new Date().getTime();
            const newId = `${now}_${RandomString(10)}_${element.type}`;
            let newObj = {
                'id': newId,
                'appId': element.appId,
                'desc': element.desc ?? '',
                'icon': element.icon,
                'name': element.name,
                'type': element.type,  
                'id_original': element.id
            }
            for (let key of Object.keys(element)) {
                if (key.includes('opt_')) {
                    const value = element[key];
                    if (
                        !key.includes('date') && 
                        !key.includes('List')
                    ) {
                        newObj[key] = value;
                    }
                }
            }
            const res = await UseCloudFunction(
                'saveToMyContent',
                {
                    'appId': userProfile.appId,
                    'source': gameData.gameName,
                    'category': category,
                    'contentData': newObj,
                    'cropped': false
                }
            )
            if (res.error) {
                setAlertMessage(`Something went wrong. Please try again later. (Error: ${res.error})`);
                return;
            }
            if (res.duplicate) {
                setAlertMessage(res.duplicate);
                setLoading(false);
                return;
            }
            console.log(res);
            setLoading(false);
            setAlertMessage('Element saved to My Content!');
            if (onComplete) onComplete();
        }
    }

    return (
        <div className={`element-savetomycontent ${classText}`}>
            {
                (style === 'button') &&
                (
                    (loading)
                    ?
                    <button
                        className='g-button med-btn'>
                        <ThreeDotsLoader />
                    </button>
                    : 
                    <button 
                        className='g-button med-btn'
                        onClick={() => saveElementToMyContent()}>
                        Save to My Content
                    </button>
                )
            }
            {
                (style === 'menu-item') &&
                (
                    (loading)
                    ?
                    <div className='element-menu-item'>
                        <ThreeDotsLoader />
                    </div>
                    :
                    <div 
                        className='element-menu-item'
                        onClick={() => saveElementToMyContent()}>
                        <FontAwesomeIcon icon={faSave} />
                        Save to My Content
                    </div>
                )
            }
            <ModalAlert
                show={alertMessage}
                cancel={() => setAlertMessage(null)}
                message={alertMessage} />
            <ModalConfirm
                show={confirmMessage}
                cancel={() => setConfirmMessage(null)}
                message={confirmMessage}
                onApprove={approveRef.current} />
        </div>
    )
}

export default ElementSaveToMyContent